import React from 'react';
type KilledItemProps = {
    name: string;
    index: number;
};

export default function KilledItem(props: KilledItemProps) {
    return (
        <td>
            <img
                src={require(`../../assets/characters/${props.name}.jpg`)}
                alt='character'
            />
        </td>
    );
}
